import { ChartUtils } from "../components/charts/utils";
import type { Period } from "../hooks/reactQueryHooks/useAnalytic";

export const getTimeInterval = (
  creationDate: number,
  trackingDate: number,
  interval?: string,
): {
  fromDate: Date;
  toDate?: Date;
  period: Period;
} => {
  // const timezoneOffset = new Date().getTimezoneOffset() * 60 * 1000;
  const dateNow = Date.now();

  switch (interval) {
    case "15M":
      return {
        fromDate: new Date(
          Math.max(dateNow - 15 * 60 * 1000, trackingDate, creationDate),
        ),
        period: "minute",
      };
    case "1H":
      return {
        fromDate: new Date(
          Math.max(dateNow - 60 * 60 * 1000, trackingDate, creationDate),
        ),
        period: "minute",
      };
    case "24H":
      return {
        fromDate: new Date(
          Math.max(dateNow - 24 * 60 * 60 * 1000, trackingDate, creationDate),
        ),
        period: "hour",
      };
    case "7D":
      return {
        fromDate: new Date(
          Math.max(
            new Date(dateNow - 6 * 24 * 60 * 60 * 1000).setUTCHours(0, 0, 0, 0),
            trackingDate,
            creationDate,
          ),
        ),
        period: "day",
      };

    case "1M": {
      const currentDate = new Date(dateNow);
      currentDate.setMonth(currentDate.getMonth() - 1);
      currentDate.setUTCHours(0, 0, 0, 0);
      return {
        fromDate: new Date(
          Math.max(trackingDate, currentDate.getTime(), creationDate),
        ),
        period: "day",
      };
    }
    case "3M": {
      const currentDate = new Date(dateNow);
      currentDate.setMonth(currentDate.getMonth() - 3);
      return {
        fromDate: new Date(
          new Date(
            Math.max(trackingDate, currentDate.getTime(), creationDate),
          ).setUTCHours(0, 0, 0, 0),
        ),
        period: "week",
      };
    }
    default:
      return {
        fromDate: new Date(Math.max(creationDate, trackingDate)),
        period: ChartUtils.getTypePeriod({
          fromDate: new Date(Math.max(creationDate, trackingDate)),
          toDate: new Date(dateNow),
        }),
      };
  }
};

export const getRequestsInterval = (
  interval?: string,
): {
  fromDate?: Date;
} | null => {
  const dateNow = Date.now();
  switch (interval) {
    case "24H":
      return {
        fromDate: new Date(dateNow - 24 * 60 * 60 * 1000),
      };
    case "7D":
      return {
        fromDate: new Date(
          new Date(dateNow - 6 * 24 * 60 * 60 * 1000).setUTCHours(0, 0, 0, 0),
        ),
      };
    case "1M":
      return {
        fromDate: new Date(
          new Date(dateNow - 30 * 24 * 60 * 60 * 1000).setUTCHours(0, 0, 0, 0),
        ),
      };
    case "3M":
      return {
        fromDate: new Date(
          new Date(dateNow - 90 * 24 * 60 * 60 * 1000).setUTCHours(0, 0, 0, 0),
        ),
      };
    default:
      return null;
  }
};
